module.exports = __webpack_public_path__ + "img/Span-04.fd36b8d4.jpg";